//読み込み時
$(window).on('load', function() {
  let headerHeight = 0;
  let urlHash = location.hash;
  if (urlHash) {
    let position = $(urlHash).offset().top - headerHeight;
    $('html, body').animate({ scrollTop: position }, 300);
  }
});

$(function(){
  $(".nav-shopping-guide>li>a").on("click",function(){
    /*if (!$(this).hasClass('is-active')) {*/
      $(this).toggleClass("is-active");
      $(this).next("ul").slideToggle(300);
      return false;
    /*}*/
  });
});